import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

interface ErrorObject {
	title: string;
	message: string;
}

@Injectable({ providedIn: 'root' })
export class ErrorService {
	errMsgObs: Observable<ErrorObject>;
	private readonly errMsgSubject = new
	BehaviorSubject<ErrorObject>({ title: '', message: '' });

	constructor() {
		this.errMsgObs = this.errMsgSubject.asObservable();
	}

	setErrorMsg(message: string, title: string) {
		this.errMsgSubject.next({ title, message });
	}

	resetErrorMsg() {
		this.errMsgSubject.next({ title: '', message: '' });
	}
}
